import type { MouseEventHandler } from "react";

import { launchRecyclableTab } from "./launchRecyclableTab";
import { logger } from "./logger";

export const openInSameTab =
  (
    url: string,
    onClickHandler?: MouseEventHandler<HTMLElement>,
  ): MouseEventHandler<HTMLElement> =>
  (event) => {
    event.preventDefault();

    const onError = (error: Error) => {
      logger.error(error, {
        extra: {
          message: `Failed to open tab for ${url}:`,
        },
      });
    };

    launchRecyclableTab(url, onError);

    if (onClickHandler) {
      onClickHandler(event);
    }
  };
